import { Outlet } from "react-router-dom";
import TopNavBar from "@/shared/components/common/TopNavBar";
import Footer from "@/shared/components/common/Footer";
import type { FC } from "react";

const MainLayout: FC = () => {
  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <TopNavBar />
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
